import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { WeeklyScheduleWidget } from './WeeklyScheduleWidget'

class HoldstyringWeeklyScheduleElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return WeeklyScheduleWidget
  }

  // Supported HTML attributes:
  //   hold-type-slugs="yoga,pilates" — only show classes tagged with these hold-mærkater
  //   title="Ugeplan"                — heading above the calendar (default: none)
  //   week-nav="false"               — hide the previous/next-week arrows
  //                                    (default: shown, so the visitor can page
  //                                    between weeks like on the studio's own site)
  //   layout="grid"                  — 7-column weekday grid (Mon..Sun) with a
  //                                    day-filter bar, like the studio's own
  //                                    ugekalender (default: "list", the rows)
  //   guests-only="true"            — gæste-fokuseret booking: stepperen vises åben
  //                                    (gæste-først) i stedet for foldet bag "+ Tilføj
  //                                    gæster". Medlemmet kan stadig booke sig selv
  //                                    uden gæster (antal starter på 0). Til en dedikeret
  //                                    gæste-adgangsside.
  protected getWidgetProps() {
    const slugsRaw = this.getAttribute('hold-type-slugs') || ''
    const holdTypeSlugs = slugsRaw.split(',').map(s => s.trim()).filter(Boolean)
    return {
      holdTypeSlugs,
      title: this.getAttribute('title') || null,
      weekNav: this.getAttribute('week-nav') !== 'false',
      layout: this.getAttribute('layout') === 'grid' ? 'grid' as const : 'list' as const,
      guestsOnly: this.getAttribute('guests-only') === 'true',
    }
  }
}

if (!customElements.get('holdstyring-weekly-schedule')) {
  customElements.define('holdstyring-weekly-schedule', HoldstyringWeeklyScheduleElement)
}

export { HoldstyringWeeklyScheduleElement }
